import { useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface LightboxCollapsibleSectionProps {
  title: string;
  /** Default collapsed; pass `true` to start expanded. */
  defaultOpen?: boolean;
  /** If true, starts open on desktop (>=md) and closed on mobile. Overrides `defaultOpen`. */
  defaultOpenDesktop?: boolean;
  children: ReactNode;
}

export function LightboxCollapsibleSection({
  title,
  defaultOpen = false,
  defaultOpenDesktop = false,
  children,
}: LightboxCollapsibleSectionProps) {
  const [open, setOpen] = useState(() => {
    if (defaultOpenDesktop && typeof window !== "undefined") {
      return window.matchMedia("(min-width: 768px)").matches;
    }
    return defaultOpen;
  });
  return (
    <div className="flex flex-col gap-1.5">
      <div className="h-px bg-border" />
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="flex items-center justify-between gap-2 w-full py-1 text-muted-foreground font-medium text-xs md:text-sm hover:text-foreground transition-colors"
      >
        <span>{title}</span>
        <ChevronDown
          className={cn(
            "w-3.5 h-3.5 transition-transform duration-200",
            open && "rotate-180"
          )}
        />
      </button>
      {open && <div className="flex flex-col gap-2 md:gap-3 pt-1">{children}</div>}
    </div>
  );
}
